// A plan someone picked on the pricing page before they had an account
// (`/signup?plan=builder`). It survives the email-verification round trip and
// the GitHub/Google redirect, which always lands on /account, so it lives in
// localStorage for an hour. Storage can be missing or blocked; every access is
// guarded and the flow works without it (they land on /account instead).

const KEY = 'willow-plan-intent';
const TTL_MS = 60 * 60 * 1000;
export const INTENT_PLANS = ['payg', 'builder', 'scale'] as const;
export type IntentPlan = (typeof INTENT_PLANS)[number];

export function isIntentPlan(v: string | null): v is IntentPlan {
  return !!v && (INTENT_PLANS as readonly string[]).includes(v);
}

export function savePlanIntent(plan: IntentPlan): void {
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ plan, at: Date.now() }));
  } catch {
    /* storage unavailable */
  }
}

/** Returns the pending plan and clears it. */
export function takePlanIntent(): IntentPlan | null {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    window.localStorage.removeItem(KEY);
    const { plan, at } = JSON.parse(raw) as { plan?: string; at?: number };
    if (!isIntentPlan(plan ?? null) || !at || Date.now() - at > TTL_MS) return null;
    return plan as IntentPlan;
  } catch {
    return null;
  }
}
